module.exports = __webpack_public_path__ + "img/up_arrow_pink_icon.44cb0e23.svg";